import React from 'react';
import Sidenavigation1 from '../../../layouts/Sidenavigation1';

import { TheMasterContextProvider } from '../../../MyContexts/Master_Context';
import { UserContextProvider } from '../../../MyContexts/Users_Context';
import Register from './Register';

const WrapRegister = (props) => {
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
                <Sidenavigation1 />
                <main className="body-content">
                    <UserContextProvider>
                        <Register />
                    </UserContextProvider>
                </main>
                {/* <Quickbar /> */}
               
            </TheMasterContextProvider>

        </div>
    );
}

export default WrapRegister;